import React from "react";
import GlobalStyle from "./assets/styles/global";
import Routes from "./routes";

function App() {
  return (
    <>
      <GlobalStyle />
      <Routes />
    </>
  );
}

export default App;
